// PhonicsLt17.js
// 包装组件：Letter Teams L17
// 路由：/phonics/lt17
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt17 } from './phonics/phonics_data_lt17';

function PhonicsLt17() {
  return <PhonicsLt letterData={letterDataLt17} />;
}

export default PhonicsLt17;
